import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IUpdateMasterPassRequest {
  id: number;
  status: string;
  systemDate: string;
  createDate: string;
  createUserId: number;
  updateDate: string;
  updateUserId: number;
  deleteDate: string;
  deleteUserId: number;
  merchantId: number;
  restriction: boolean;
  clientId: number;
  encKey: string;
  macKey: string;
  terminalGroupId: string;
}

async function updateMasterPass(data: IUpdateMasterPassRequest): Promise<any> {
  try {
    return (await axiosInstance.put("/MasterPass/UpdateDefinition", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useUpdateMasterPass() {
  return useMutation<any, Error, IUpdateMasterPassRequest>(
    (variables) => updateMasterPass(variables)
  );
}
